import { CircularProgress, IconButton } from "@mui/material";
import CloseIcon from '@mui/icons-material/Close';
import { useEffect, useState } from "react";
import api from "../../../../api/api";
import { useSelector } from "react-redux";

const ProcedureDocument = ({ isProcedureDocumentOpen,subview, setIsProcedureDocumentOpen, procedure }) => {
    const [imagingData, setImagingData] = useState([]); // State for fetched imaging data
    const [imageUrls, setImageUrls] = useState([]); // State for image URLs
    const [isLoading, setIsLoading] = useState(false);
    const patientId = procedure.patientid; 
    console.log(procedure,'pro')
    const practiseid = window.getPracticeId();
 const userConfig = useSelector((state) => state.userconfig);
    const fetchImagingData = async () => {
        setIsLoading(true);
        try {
         const payload = {
  patientid: patientId,
  imagingresultid:
    subview === 0
      ? procedure.documentclass === "IMAGINGRESULT"
        ? procedure.imagingresultid
        : procedure.encounterdocumentid
      : subview === 1
      ? procedure.imagingresultid
      : procedure.encounterdocumentid,
  category:
    subview === 0
      ? procedure.documentclass === "IMAGINGRESULT"
        ? "Procedures"
        : "ProgressNotes"
      : subview === 1
      ? "Procedures"
      : "ProgressNotes",
};


            const response = await api.post(`/v1/${practiseid}/patient/${patientId}/procedures/image-result`, payload);

            if (response.status === 200) {
                console.log("Fetched Imaging Data:", response.data);
                setImagingData(response.data || []); // Fallback to empty array if data is undefined
            } else {
                console.error("Unexpected response:", response);
            }
        } catch (error) {
            console.error("Error fetching imaging data:", error.response ? error.response.data : error);
        } finally {
            setIsLoading(false);
        }
    };
 const fetchclinicalData = async () => {
        setIsLoading(true);
        try {
            const payload = {
                patient_id: patientId,
                   "department_id": userConfig.config.departmentid, 
                  "clinicaldocument_id": procedure.clinicaldocumentid
            };

            const response = await api.post(`/v1/${practiseid}/clinical-documents-by-id`, payload);

            if (response.status === 200) {
                console.log("Fetched Imaging Data:", response.data);
                setImagingData(response.data || []); // Fallback to empty array if data is undefined
            } else {
                console.error("Unexpected response:", response);
            }
        } catch (error) {
            console.error("Error fetching imaging data:", error.response ? error.response.data : error);
        } finally {
            setIsLoading(false);
        }
    };
    const fetchImageUrls = async (pages) => {
        setIsLoading(true);
        const urls = [];

        for (const page of pages) {
            try {
                const payload = { url: page.href }; // Use the href from the page
                const response = await api.post(`/v1/${practiseid}/procedures/get-image`, payload);

                if (response.status === 200) {
                    console.log("Fetched Image URL:", response.data);
                    urls.push(response.data || ""); // Collect URLs
                } else {
                    console.error("Unexpected response:", response);
                }
            } catch (error) {
                console.error("Error fetching image URL:", error.response ? error.response.data : error);
            }
        }

        setImageUrls(urls);
        setIsLoading(false);
    };

    useEffect(() => {
        if (isProcedureDocumentOpen && patientId && (procedure.encounterdocumentid||procedure.imagingresultid||procedure.clinicaldocumentid)) {
          if (
  subview === 3 ||
  (subview === 0 && procedure?.documentclass === "CLINICALDOCUMENT")
) {
  fetchclinicalData();
  return;
}

            fetchImagingData();
        }
    }, [isProcedureDocumentOpen]);

    useEffect(() => {
        if (imagingData.length > 0) {
            const pages = imagingData[0]?.pages || [];
            if (pages.length > 0) {
                fetchImageUrls(pages); // Call fetchImageUrls with the fetched pages
            }
        }
    }, [imagingData]);

    if (!isProcedureDocumentOpen) return null;

    const pages = imagingData[0]?.pages || [];

    return (
        <div className="fixed inset-0 flex items-center justify-center z-50 " onClick={() => setIsProcedureDocumentOpen(false)}>
            <div className="absolute inset-0 bg-black/50 opacity-50"></div>
            <div
                className="relative z-10 max-w-xxl min-w-[600px] h-[100%] overflow-y-auto scrollbar-hidden p-4 rounded-sm bg-white shadow-custom flex flex-col items-center"
                onClick={(e) => e.stopPropagation()} // Prevent closing when clicking inside the popup
            >
                <div className="p-2 w-full flex justify-between items-center border-b-2">
                    <div className="h-6 font-medium text-[#1d2951] text-lg tracking-[0] leading-6 whitespace-nowrap">
                        Result 
                    </div>
                    <IconButton
                        edge="end"
                        aria-label="close"
                        onClick={() => setIsProcedureDocumentOpen(false)}
                        style={{ color: '#C7C7CB' }}
                    >
                        <CloseIcon />
                    </IconButton>
                </div>
                <div className="space-y-4">
                    {isLoading ? (
                        <div className="text-center text-gray-500 h-full"> 
                           <div className="mt-20">
                           <CircularProgress />
                           </div>
                        </div> // Loading indicator
                    ) : pages.length > 0 ? (
                        pages.map((page, index) => (
                            <div key={page.pageid} className="flex items-center">
                                <img
                                    src={imageUrls[index]} // Use the fetched URL
                                    alt={`Document page ${page.pageid} `}
                                    className="w-full h-auto rounded-lg"
                                    onError={() => console.error(`Failed to load image at ${imageUrls[index]}`)} 
                                />
                            </div>
                        ))
                    ) : (
                        <div className="text-center text-gray-500">No pages available.</div> // Message if no pages are available
                    )}
                </div>
            </div>
        </div>
    );
};

export default ProcedureDocument;
